<div class="perfil">
    <div class="foto">
        <i class="hgi hgi-stroke hgi-user"></i>
    </div>

    <div class="informacoes">
        <h4>{{ nome }}</h4>
        <span *ngIf="!expanded" class="tipo-usuario">
            {{ tipoUsuario }}
        </span>

        <div class="detalhes" *ngIf="expanded">

            <ng-container *ngIf="showProfissional">
                <div class="detalhe">
                    <i class="hgi hgi-stroke hgi-stethoscope-02"></i>
                    <span>Clínico Geral</span>
                </div>
                <div class="detalhe">
                    <i class="hgi hgi-stroke hgi-passport-valid"></i>
                    <span>CRM/SP 123456</span>
                </div>
                <div class="detalhe">
                    <i class="hgi hgi-stroke hgi-save-money-dollar"></i>
                    <span>A partir de R$ 120,00</span>
                </div>
            </ng-container>

            <ng-container *ngIf="showPaciente && paciente">
                <div class="detalhe">
                    <i class="hgi hgi-stroke hgi-student-card"></i>
                    <span>{{ paciente.nome }}</span>
                </div>

                <div class="detalhe">
                    <i class="hgi hgi-stroke hgi-mail-01"></i>
                    <span>{{ paciente.email }}</span>
                </div>

                <div class="detalhe">
                    <i class="hgi hgi-stroke hgi-birthday-cake"></i>
                    <span>{{ paciente.idade }} Anos</span>
                </div>

                <div class="detalhe">
                    <i class="hgi hgi-stroke hgi-dna-01"></i>
                    <span>Sexo {{ paciente.sexoDescricao }}</span>
                </div>

                <div class="detalhe">
                    <i class="hgi hgi-stroke hgi-mask"></i>
                    <div class="alergias">
                        <div class="alergia">
                            <i class="hgi hgi-stroke hgi-alert-02"></i>
                            <span>Rinite alérgica</span>
                        </div>

                        <div class="alergia">
                            <i class="hgi hgi-stroke hgi-alert-02"></i>
                            <span>Asma</span>
                        </div>

                        <div class="alergia">
                            <i class="hgi hgi-stroke hgi-alert-02"></i>
                            <span>Bronquite</span>
                        </div>
                    </div>
                    <div class="link">
                        <a href="javascript:void(0)" (click)="openProntuario(paciente)">
                            Ver detalhes
                            <i class="hgi hgi-stroke hgi-arrow-right-02"></i>
                        </a>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>